import React from "react";

import { CellContext, HeaderContext } from "@tanstack/react-table";

import type { LibreViewClinicPatient } from "@/models/LibreViewModel.ts";
import { Checkbox } from "@/uiKit/atoms/inputs/Checkbox.tsx";

export const SelectHeader: React.FC<HeaderContext<LibreViewClinicPatient, unknown>> = ({ table }) => {
  return (
    <Checkbox
      id="sync-grouped-inclusion-select-all"
      checked={table.getIsAllPageRowsSelected()}
      indeterminate={table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected()}
      onChange={() => table.toggleAllPageRowsSelected()}
    />
  );
};

export const SelectCell: React.FC<CellContext<LibreViewClinicPatient, unknown>> = ({ row }) => (
  <Checkbox
    id={`sync-grouped-inclusion-select-${row.original.libreviewId}`}
    checked={row.getIsSelected()}
    onChange={() => row.toggleSelected()}
  />
);
